<section [style]="styles" class="flex w-full gap-8 items-center">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="titleColor"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="labelBlock?.fontFamily"
      [fontSize]="labelBlock?.fontSize"
      [fontStyle]="labelBlock?.fontStyle"
      [fontWeight]="labelBlock?.fontWeight"
      [horizontalAlign]="title?.align"
      [icon]="title?.icon"
      [iconColor]="titleIconColor"
      [iconPosition]="title?.iconPosition"
      [iconSize]="labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="labelBlock?.lineHeight"
      [position]="title?.position"
      [tooltip]="title?.tooltip"
      [width]="title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }

  <div
    class="score-control min-w-0 flex-1 {{ elementKeyRoot }} {{ elementKey }}"
    data-cy="Score:control"
    [class.validation-error]="hasValidationError"
    role="radiogroup"
    [attr.aria-label]="labelText || 'Score'"
    [attr.aria-disabled]="isReadonly || null"
    (keydown)="onKeydown($event)"
  >
    @for (scoreValue of values(); track scoreValue) {
      <button
        #scoreOption
        type="button"
        class="score-value"
        data-cy="Score:option"
        role="radio"
        [class.score-value--selected]="scoreValue === currentScore()"
        [attr.aria-checked]="scoreValue === currentScore()"
        [attr.tabindex]="tabIndexFor(scoreValue)"
        [disabled]="isReadonly"
        (click)="selectValue(scoreValue)"
      >
        {{ scoreValue }}
      </button>
    }
  </div>
</section>

@if (hasValidationError) {
  <div class="mt-1 text-xs text-warn" [style]="validationStyles">
    {{ formState?.messages?.required || '' }}
  </div>
}
